import { __decorate, __extends } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import CategorizeBox from "@/components/categorizeBox/index.vue";
import FormPage from "./addEditCopy/index.vue";

var GPSRInfoMaintainPage = function (_super) {
  __extends(GPSRInfoMaintainPage, _super);

  function GPSRInfoMaintainPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GPSRInfoMaintainPage.prototype.created = function () {};

  GPSRInfoMaintainPage = __decorate([Component({
    components: {
      CategorizeBox: CategorizeBox,
      FormPage: FormPage
    }
  })], GPSRInfoMaintainPage);
  return GPSRInfoMaintainPage;
}(Vue);

export default GPSRInfoMaintainPage;